import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { FixedSizeList as List } from "react-window";
import { Card, CardBody } from "reactstrap";

import { H3, MUIIcons } from "../../../../../AbstractElements";
import Divider from "../../../../../CommonElements/Divider";
import CommonModal from "../../../../../CommonElements/Modal";
import UserActionCard from "../../../../../container/UserActionCard";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { deleteUserFromGroup } from "../../../../../ReduxToolkit/Reducers/UserGroupSlice";
import {
  AddModifyLearningPlan,
  AreYouSureDelete,
  ComingSoon,
  Confirm,
  Confirmation,
  Remove,
  UserDetails as UserDetailsHeader,
} from "../../../../../utils/Constant";
import {
  formatCustomDate,
  showToast,
} from "../../../../../utils/helper/helper";
import ModifyLearningPlan from "../ModifyLearnigPlan";

const UserDetails = ({ group_id, users, userMap, getByTab }) => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [modalInfo, setModalInfo] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const [itemSize, setItemSize] = useState(100);

  const updateItemSize = () => {
    const width = window.innerWidth;
    if (width <= 767) {
      setItemSize(220);
    } else if (width <= 1023) {
      setItemSize(240);
    } else {
      setItemSize(80);
    }
  };

  useEffect(() => {
    updateItemSize();
    window.addEventListener("resize", updateItemSize);
    return () => {
      window.removeEventListener("resize", updateItemSize);
    };
  }, []);

  const handleModal = () => {
    setOpenModal(prevState => !prevState);
  };

  const handleDropdown = (value, id) => {
    setSelectedId(id);
    if (value === "item1") {
      handleConfirmDelete(id);
    }
    if (value === "item2") {
      handleModal();
    }
  };

  const handleConfirmDelete = id => {
    setModalInfo({
      isOpen: true,
      title: AreYouSureDelete,
      callback: () => handleDelete(id),
    });
  };

  const handleDelete = async id => {
    await dispatch(
      deleteUserFromGroup({
        payload: {
          id: Number(group_id),
          users: [id],
        },
      })
    );
    await getByTab();
    closeModal();
  };

  const closeModal = () => {
    setModalInfo(null);
  };

  return (
    <Card>
      <CommonModal
        sizeTitle={Confirmation}
        modalBodyClassName=""
        isOpen={modalInfo?.isOpen}
        toggle={closeModal}
        backdrop="static"
        size="lg"
        showFooter
        onPrimaryBtnClick={modalInfo?.callback}
        primaryBtnText={Confirm}
      >
        {modalInfo?.title}
      </CommonModal>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mt-2">
          <H3 className="fw-bold">{UserDetailsHeader}</H3>
          <div>
            <MUIIcons
              className="primary-icon-color pointer"
              size={24}
              iconName="FileDownloadOutlined"
              onClick={() => {
                showToast(ComingSoon, "warning");
                return;
              }}
            />
          </div>
        </div>
        <Divider />
        {users?.length > 0 && (
          <List
            height={400}
            itemCount={users?.length || 0}
            itemSize={itemSize}
            width="100%"
            className="user-list__card-container"
          >
            {({ index, style }) => {
              const item: any = users[index];
              if (userMap) {
                const details = {
                  unique_id: item?.id,
                  id: userMap[item?.id]?.id,
                  participant_id: userMap[item?.id]?.id,
                  name: userMap[item?.id]?.user_name,
                  user_name: userMap[item?.id]?.user_name,
                  empId: userMap[item?.id]?.employee_code,
                  userId: userMap[item?.id]?.id,
                  mobile: userMap[item?.id]?.phone,
                  sbu: userMap[item?.id]?.sbu || "-",
                  rmName: userMap[item?.id]?.mapped_rm[0]?.name || "-",
                  rmMobileNo: userMap[item?.id]?.mapped_rm[0]?.rm_phone || "-",
                  addedOn: item?.added_on
                    ? formatCustomDate(item?.added_on)
                    : "-",
                };

                return (
                  <div key={item.id} style={style} className="mt-3">
                    <UserActionCard
                      userDetails={details}
                      actions={true}
                      firstItem={Remove}
                      secondItem={AddModifyLearningPlan}
                      onClickDropdownItem={value =>
                        handleDropdown(value, item?.id)
                      }
                    />
                    <Divider />
                  </div>
                );
              }
              return null;
            }}
          </List>
        )}
      </CardBody>

      <ModifyLearningPlan
        group_id={group_id}
        selectedId={selectedId}
        openModal={openModal}
        handleModal={handleModal}
      />
    </Card>
  );
};

UserDetails.propTypes = {
  group_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      added_on: PropTypes.string,
      participant_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  userMap: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      user_name: PropTypes.string,
      employee_code: PropTypes.string,
      sbu: PropTypes.any,
      phone: PropTypes.string,
      mapped_rm: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          rm_phone: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  sbuMap: PropTypes.objectOf(PropTypes.string).isRequired,
  getByTab: PropTypes.func.isRequired,
};

export default UserDetails;
